import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  TablePagination,
  Avatar,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { ArrowLeft } from "@mui/icons-material";
import { usePreference } from "../context/UserContext";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AdvertisementModel from "../common/AdvertisementModel";
import PayPalModal from "./paypal/PaypalModel";
import QuizzesModel from "../common/QuizzesModel";
import ShowCart from "./ShowCart";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function Users() {
  const location = useLocation();
  const { subcategories = [] } = location.state || {};
  const navigate = useNavigate();
  const {
    updateIsLoginOpen,
    updateIsSignUpOpen,
    updateIsNavVisible,
    showCart,
    updateShowCart,
    cart,
    updateCart,
  } = usePreference();
  const [updateLoading, setupdateLoading] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [data, setData] = useState([]);
  const [expandedPacks, setExpandedPacks] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const username = localStorage.getItem("username");
  const userRole = localStorage.getItem("userrole");
  const [openQuizModel, setOpenQuizModel] = useState(false);
  const [catId, setCatId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [isCollectionId, setIsCollectionId] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [amount, setAmount] = useState(1);
  const [filteredCart, setFilteredCart] = useState([]);
  const [showPaypalModel, setShowPaypalModel] = useState(false);
  const [pack, setPack] = useState({});
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const scrollContainerRefs = useRef({});
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("UserName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterVerified, setFilterVerified] = useState("");
  const [filterPhoto, setFilterPhoto] = useState("");
  const [roles, setRoles] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState("");
  useEffect(() => {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<style>@keyframes blink {0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}}</style>`
    );
  }, []);

  useEffect(() => {
    updateIsNavVisible(true);
    const fetchData = async () => {
      setFilteredData([subcategories]);
    };
    fetchData();
  }, [username, userRole, subcategories, updateIsNavVisible]);

  useEffect(() => {
    if (cart.length === 0) {
      updateShowCart(false);
    } else {
      const filteredCartData = cart.map((item) => ({
        packId: item.packId,
        price: item.price,
        isCollection: item.isCollection,
        type: item.type === "monthly",
      }));
      setFilteredCart(filteredCartData);
    }
  }, [cart, updateShowCart]);

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) updateCart(JSON.parse(savedCart));
  }, [updateCart]);

  useEffect(() => {
    setLoading(true);
    const storedRole = localStorage.getItem("userrole");
    setCurrentUserRole(storedRole);
    console.log(currentUserRole);
    const fetchUsersAndRoles = async () => {
      try {
        const [userRes, roleRes] = await Promise.all([
          fetch("https://s3napi-dev.s3nsoftware.com/api/UserMaster/Users"),
          fetch("https://s3napi-dev.s3nsoftware.com/api/UserMasters/Userroles"),
        ]);

        const users = await userRes.json();
        const rolesData = await roleRes.json();

        const transformedUsers = users.map((item) => ({
          ...item,
          UserPhoto:
            item.UserPhoto &&
            `https://s3nsoftware.com/profilepics/${item.UserPhoto}.jpg`,
        }));

        setRows(transformedUsers);
        setRoles(rolesData);
        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch users or roles:", error);
      }
    };

    fetchUsersAndRoles();
  }, []);
  const getQuizUrlByGradeIndex = (index) => {
    if (index === 0 || index === 1) return "/playquiz/56";
    if (index === 2 || index === 3) return "/playquiz/57";
    if (index >= 4 && index <= 7) return "/playquiz/58";
    return "/";
  };

  const getQuizPackMessage = (index) => {
    if (index === 0 || index === 1) return "(Dictionary 1 recommended)";
    if (index === 2) return "(Dictionary 2 recommended)";
    if (index === 3) return "(Dict 3 recommended)";
    if (index >= 4 && index <= 7) return "(Dictionary 4 and 5 recommended)";
    return "";
  };

  const togglePackVisibility = (packId) => {
    setExpandedPacks((prev) => ({
      ...prev,
      [packId]: !prev[packId],
    }));
  };

  const updateQuizId = (value) => {
    navigate(`/playquiz/${value}`);
  };

  const addToCart = (pack, type, price, isCollection, action, packname) => {
    updateShowCart(true);
    updateCart((prevCart) => {
      const currentCart = Array.isArray(prevCart) ? prevCart : [];
      if (action === "add") {
        const itemAlreadyInCart = currentCart.some(
          (item) =>
            item.packId === pack.Id && item.isCollection === isCollection
        );
        if (itemAlreadyInCart) {
          Swal.fire({
            title: "Info",
            text: "This item is already in your cart.",
            icon: "info",
          });
          return currentCart;
        }
        if (isCollection) {
          if (Array.isArray(pack.Categories)) {
            const categoryAlreadyInCart = currentCart.some((item) =>
              pack.Categories.some(
                (category) => item.packId === category.CollectionId
              )
            );
            if (categoryAlreadyInCart) {
              Swal.fire({
                title: "Alert",
                text: "Some categories from this collection are already in your cart. Please remove them first if you wish to add the entire collection.",
                icon: "warning",
              });
              return currentCart;
            }
            const updatedCart = currentCart.filter(
              (item) =>
                !pack.Categories.some(
                  (category) => item.packId === category.CollectionId
                )
            );
            const newCartItem = {
              pack,
              packId: pack.Id,
              type,
              price,
              isCollection,
              packname,
            };
            const newCart = [...updatedCart, newCartItem];
            localStorage.setItem("cart", JSON.stringify(newCart));
            return newCart;
          }
        } else {
          const collectionInCart = currentCart.some(
            (item) => item.packId === pack.CollectionId
          );
          if (collectionInCart) {
            Swal.fire({
              title: "Alert",
              text: "The collection containing this category is already in your cart. You cannot add individual categories from the collection.",
              icon: "warning",
            });
            return currentCart;
          }
          const newCartItem = {
            pack,
            packId: pack.Id,
            type,
            price,
            isCollection: false,
            packname,
          };
          const newCart = [...currentCart, newCartItem];
          localStorage.setItem("cart", JSON.stringify(newCart));
          return newCart;
        }
      } else if (action === "remove") {
        const updatedCart = currentCart.filter(
          (item) =>
            !(item.packId === pack.Id && item.isCollection === isCollection)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart;
      }
    });
  };

  const handleCheckout = () => {
    const loggedin = localStorage.getItem("loggedin");
    if (!loggedin || loggedin === "false") {
      Swal.fire({
        icon: "warning",
        text: "Please login or signup to subscribe",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Login",
        denyButtonText: "Sign Up",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          updateIsLoginOpen(true);
          updateIsSignUpOpen(false);
        } else if (result.isDenied) {
          updateIsSignUpOpen(true);
          updateIsLoginOpen(false);
        }
      });
      return;
    }
    setAmount(calculateTotal());
    setShowPaypalModel(true);
  };

  const deleteItem = (packId, type) => {
    updateCart((prevCart) => {
      const updatedCart = prevCart.filter(
        (item) => !(item.packId === packId && item.type === type)
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });
  };

  const toggleCartVisibility = () => {
    updateShowCart(!showCart);
  };

  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price, 0).toFixed(2);
  };

  const updateQuizModel = (value) => {
    setOpenQuizModel(value);
  };

  const updateShowPaypalModel = (value) => {
    setShowPaypalModel(value);
  };

  const updateOpenAdd = (value) => {
    setIsOpenAdd(value);
  };

  const handleRoleChange = async (id, newRole) => {
    setupdateLoading(true);
    const userToUpdate = rows.find((row) => row.Id === id);

    if (!userToUpdate) {
      console.error("User not found");
      return;
    }

    const updatedUser = {
      ...userToUpdate,
      UserRoles: newRole,
      LastActivity: new Date().toISOString().split("T")[0],
    };

    try {
      const response = await fetch(
        "https://s3napi-dev.s3nsoftware.com/api/UserMasters/UpdateUserroles",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedUser),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update user role");
      }

      setRows((prevRows) =>
        prevRows.map((row) =>
          row.Id === id ? { ...row, UserRoles: newRole } : row
        )
      );
      setupdateLoading(false);
    } catch (error) {
      setupdateLoading(false);
      console.error("Error updating user role:", error);
      alert("Failed to update user role. Please try again.");
    }
  };

  const filteredAndSortedRows = useMemo(() => {
    return rows
      .filter((row) => {
        const nameMatch = row.UserName?.toLowerCase().includes(
          search.toLowerCase()
        );
        const emailMatch = row.UserEmailId?.toLowerCase().includes(
          search.toLowerCase()
        );

        const verifiedMatch =
          filterVerified === ""
            ? true
            : filterVerified === "verified"
            ? !!row.Verifiedon
            : !row.Verifiedon;

        const photoMatch =
          filterPhoto === ""
            ? true
            : filterPhoto === "with_photo"
            ? !!row.UserPhoto
            : !row.UserPhoto;

        return (nameMatch || emailMatch) && verifiedMatch && photoMatch;
      })
      .sort((a, b) => {
        let aVal, bVal;

        if (sortField === "joined_date") {
          aVal = new Date(a.Verifiedon || 0);
          bVal = new Date(b.Verifiedon || 0);
        } else if (sortField === "recent_login") {
          aVal = new Date(a.LastActivity || 0);
          bVal = new Date(b.LastActivity || 0);
        } else {
          aVal = a[sortField]?.toLowerCase?.() || "";
          bVal = b[sortField]?.toLowerCase?.() || "";
        }

        if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
  }, [rows, search, sortField, sortOrder, filterVerified, filterPhoto]);

  return (
    <div style={{ margin: "5%" }}>
      {showCart && (
        <ShowCart
          showCart={showCart}
          toggleCartVisibility={toggleCartVisibility}
          cart={cart}
          deleteItem={deleteItem}
          handleCheckout={handleCheckout}
          calculateTotal={calculateTotal}
          filteredCart={filteredCart}
        />
      )}

      {openQuizModel && (
        <QuizzesModel
          open={openQuizModel}
          updateQuizModel={updateQuizModel}
          catId={catId}
          updateQuizId={updateQuizId}
          pack={pack}
        />
      )}

      <PayPalModal
        showPaypalModel={showPaypalModel}
        updateShowPaypalModel={updateShowPaypalModel}
        amount={amount}
        SelectedId={12}
        IsCollectionId={true}
        IsMonthly={true}
        Username={username}
        cartdata={cart}
        filteredCart={filteredCart}
      />
      <AdvertisementModel open={isOpenAdd} updateIsOpen={updateOpenAdd} />
      {loading ? (
        <Backdrop
          sx={{
            color: "#000",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <div style={{ textAlign: "center" }}>
            <CircularProgress sx={{ color: "#007bff" }} />
            <p style={{ marginTop: "8px", fontWeight: "500" }}>Loading...</p>
          </div>
        </Backdrop>
      ) : (
        <>
          <Backdrop
            sx={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={updateLoading}
          >
            <div style={{ textAlign: "center" }}>
              <CircularProgress sx={{ color: "#007bff" }} />
              <p style={{ marginTop: "8px", fontWeight: "500" }}>Loading...</p>
            </div>
          </Backdrop>
          <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "4px 8px",
                backgroundColor: "#e5e7eb",
                color: "#374151",
                borderRadius: "12px",
                border: "none",
                cursor: "pointer",
              }}
            >
              <a
                href="/"
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <ArrowLeft size={20} />
                <span style={{ fontSize: "16px", fontWeight: "500" }}>
                  Back
                </span>
              </a>
            </button>
            <TextField
              sx={{ width: "50%" }}
              label="Search by name or email"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Sort by</InputLabel>
              <Select
                value={sortField}
                label="Sort by"
                onChange={(e) => setSortField(e.target.value)}
              >
                <MenuItem value="UserName">Name</MenuItem>
                <MenuItem value="joined_date">Joined Date</MenuItem>
                <MenuItem value="recent_login">Recent Login</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Order</InputLabel>
              <Select
                value={sortOrder}
                label="Order"
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell></StyledTableCell>
                  <StyledTableCell align="right">Name</StyledTableCell>
                  <StyledTableCell align="right">Email</StyledTableCell>
                  <StyledTableCell align="right">Joined Date</StyledTableCell>
                  <StyledTableCell align="right">Recent Login</StyledTableCell>
                  <StyledTableCell align="right">User Roles</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredAndSortedRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <StyledTableRow key={row.Id}>
                      <StyledTableCell component="th" scope="row">
                        {row.UserPhoto ? (
                          <img
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                            src={row.UserPhoto}
                            // alt={row.UserName}
                          />
                        ) : (
                          <Avatar
                            alt={row.UserName}
                            src={row.UserPhoto}
                            sx={{ width: 48, height: 48 }}
                          >
                            {row.UserName?.charAt(0).toUpperCase()}
                          </Avatar>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.UserName}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.UserEmailId}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.Verifiedon
                          ? new Date(row.Verifiedon).toLocaleDateString()
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.LastActivity
                          ? new Date(row.LastActivity).toLocaleString()
                          : "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Select
                          value={row.UserRoles || "User"}
                          onChange={(e) =>
                            handleRoleChange(row.Id, e.target.value)
                          }
                          variant="standard"
                          sx={{ minWidth: 120 }}
                          disabled={currentUserRole !== "SuperAdmin"}
                        >
                          {roles.map((role) => (
                            <MenuItem key={role} value={role}>
                              {role}
                            </MenuItem>
                          ))}
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredAndSortedRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
            />
          </TableContainer>
        </>
      )}
    </div>
  );
}
